// 演示房源数据（虚构，仅用于展示）
// 图片来源 Unsplash（可免费商用），存于 src/assets/properties/ 下 exterior/interior/shop 三个图库

/* ---------- 图片库（按类别循环使用） ---------- */
const EXT = [
  require('@/assets/properties/exterior/ext3.jpg'),
  require('@/assets/properties/exterior/ext4.jpg'),
  require('@/assets/properties/exterior/ext5.jpg'),
  require('@/assets/properties/exterior/ext6.jpg'),
  require('@/assets/properties/exterior/ext7.jpg'),
  require('@/assets/properties/exterior/ext8.jpg'),
  require('@/assets/properties/exterior/ext9.jpg'),
  require('@/assets/properties/exterior/ext10.jpg'),
  require('@/assets/properties/exterior/ext11.jpg'),
  require('@/assets/properties/exterior/ext12.jpg'),
  require('@/assets/properties/exterior/ext13.jpg'),
  require('@/assets/properties/exterior/ext14.jpg'),
  require('@/assets/properties/exterior/ext15.jpg'),
]
const INT = [
  require('@/assets/properties/interior/int1.jpg'),
  require('@/assets/properties/interior/int2.jpg'),
  require('@/assets/properties/interior/int3.jpg'),
  require('@/assets/properties/interior/int4.jpg'),
  require('@/assets/properties/interior/int5.jpg'),
  require('@/assets/properties/interior/int6.jpg'),
  require('@/assets/properties/interior/int7.jpg'),
  require('@/assets/properties/interior/int8.jpg'),
  require('@/assets/properties/interior/int9.jpg'),
  require('@/assets/properties/interior/int10.jpg'),
  require('@/assets/properties/interior/int11.jpg'),
  require('@/assets/properties/interior/int12.jpg'),
  require('@/assets/properties/interior/int13.jpg'),
  require('@/assets/properties/interior/int14.jpg'),
]
const SHOP = [
  require('@/assets/properties/shop/shop1.jpg'),
  require('@/assets/properties/shop/shop3.jpg'),
  require('@/assets/properties/shop/shop4.jpg'),
  require('@/assets/properties/shop/shop5.jpg'),
  require('@/assets/properties/shop/shop8.jpg'),
  require('@/assets/properties/shop/shop9.jpg'),
  require('@/assets/properties/shop/shop10.jpg'),
  require('@/assets/properties/shop/shop11.jpg'),
  require('@/assets/properties/shop/shop12.jpg'),
]
// 住宅（二手房/新房）图库：外观与室内交替，视觉更丰富
const RESIDENTIAL_IMGS = (() => {
  const out = []
  const max = Math.max(EXT.length, INT.length)
  for (let i = 0; i < max; i++) {
    if (EXT[i]) out.push(EXT[i])
    if (INT[i]) out.push(INT[i])
  }
  return out
})()

/* ---------- 基础数据池 ---------- */
// 各区县 + 楼盘/小区名（贴近嘉兴本地）
const AREAS = [
  { district: '南湖区', names: ['南湖天地', '中港城', '嘉华随园', '运河名邸', '越秀天悦江湾', '中山锦园', '东方都市花园'] },
  { district: '秀洲区', names: ['万科翡翠公园', '中央公园', '新城香溢紫郡', '融创玖樟台', '秀湖广场', '高照未来社区'] },
  { district: '经开区', names: ['海棠公馆', '南江公寓', '中南春溪集', '长水塘畔', '东方巴黎'] },
  { district: '嘉善县', names: ['高铁新城', '绿城桂语江南', '西塘水乡', '罗星里', '大云温泉小镇'] },
  { district: '平湖市', names: ['当湖新城', '东湖明珠', '港区新城', '钟埭花园'] },
  { district: '海盐县', names: ['武原新城', '南北湖畔', '滨海新城', '西塘桥'] },
  { district: '海宁市', names: ['鹃湖国际', '皮革城', '盐官古城', '百合新城', '长安高新'] },
  { district: '桐乡市', names: ['凤凰湖畔', '乌镇人家', '梧桐街道', '崇福古镇', '振兴东路'] },
]
const SHOP_AREAS = [
  { district: '南湖区', names: ['八佰伴商圈', '禾城中心', '中山路商业街'] },
  { district: '秀洲区', names: ['万达广场', '秀洲商业中心'] },
  { district: '嘉善县', names: ['世贸广场', '高铁新城商业街'] },
  { district: '海宁市', names: ['皮革城', '鹃湖商业街'] },
  { district: '平湖市', names: ['当湖商业中心', '港区商业街'] },
  { district: '桐乡市', names: ['崇福商业中心', '乌镇景区商街'] },
]

// 住宅户型（含面积区间、卧室数）
const HOME_LAYOUTS = [
  { rooms: 1, layout: '1室1厅1卫', area: [48, 62], label: '温馨一房' },
  { rooms: 2, layout: '2室1厅1卫', area: [66, 80], label: '舒适两房' },
  { rooms: 2, layout: '2室2厅1卫', area: [80, 96], label: '阳光两房' },
  { rooms: 3, layout: '3室2厅1卫', area: [95, 118], label: '品质三房' },
  { rooms: 3, layout: '3室2厅2卫', area: [110, 138], label: '改善三房' },
  { rooms: 4, layout: '4室2厅2卫', area: [135, 172], label: '阔景四房' },
  { rooms: 5, layout: '5室3厅3卫', area: [190, 260], label: '联排别墅' },
]
const RENT_LAYOUTS = [
  { rooms: 0, layout: '开间', area: [30, 42], label: '精致开间' },
  { rooms: 1, layout: '1室1厅1卫', area: [42, 58], label: '温馨一房' },
  { rooms: 2, layout: '2室1厅1卫', area: [60, 78], label: '舒适两房' },
  { rooms: 2, layout: '2室2厅1卫', area: [78, 92], label: '阳光两房' },
  { rooms: 3, layout: '3室2厅1卫', area: [92, 118], label: '合租三房' },
]
const SHOP_LAYOUTS = [
  { layout: '临街商铺', area: [35, 70], label: '临街旺铺' },
  { layout: '沿街一层', area: [45, 90], label: '沿街商铺' },
  { layout: '商住两用', area: [50, 110], label: '商住两用' },
  { layout: '1-2层旺铺', area: [90, 180], label: '双层旺铺' },
]
const FLOORS = ['低楼层', '中楼层', '中高楼层', '高楼层', '顶层复式']
const SHOP_FLOORS = ['临街一层', '沿街商铺', '1-2层', '街角旺铺']

const TAGS = {
  二手房: ['满五唯一', '近地铁', '南北通透', '学区房', '精装修', '边套', '采光好', '户型方正', '诚心出售', '送车位'],
  新房: ['品牌开发商', '精装交付', '低密社区', '公园旁', '人车分流', '大平层', '准现房', '洋房', '高绿化', '配套成熟'],
  租赁: ['拎包入住', '家电齐全', '近地铁', '随时看房', '押一付一', '独立卫浴', '采光充足', '新装修', '近学校', '有阳台'],
  商铺: ['临街旺铺', '客流密集', '可餐饮', '展示面广', '即租即用', '商圈成熟', '人流量大', '双开间', '层高足', '可明火'],
}

/* ---------- 确定性伪随机（按 id 生成，保证稳定可复现） ---------- */
function mulberry32(seed) {
  return function () {
    seed |= 0
    seed = (seed + 0x6d2b79f5) | 0
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
const pick = (rng, arr) => arr[Math.floor(rng() * arr.length)]
const between = (rng, min, max) => min + Math.floor(rng() * (max - min + 1))
function pickTags(rng, type) {
  const pool = [...TAGS[type]]
  const n = between(rng, 2, 3)
  const out = []
  for (let i = 0; i < n && pool.length; i++) out.push(pool.splice(Math.floor(rng() * pool.length), 1)[0])
  return out
}

/* ---------- 房源生成 ---------- */
let seq = 0
function makeResidential(type, count) {
  const list = []
  for (let i = 0; i < count; i++) {
    const id = ++seq
    const rng = mulberry32(id * 2654435761)
    const area = pick(rng, AREAS)
    const community = pick(rng, area.names)
    const lot = pick(rng, HOME_LAYOUTS)
    const size = between(rng, lot.area[0], lot.area[1])
    const floor = lot.rooms >= 5 ? '独栋/联排' : pick(rng, FLOORS)
    // 单价（万/㎡）：新房略高
    const perSqm = (type === '新房' ? 1.9 : 1.6) + rng() * 1.5
    const total = Math.round(size * perSqm)
    list.push({
      id,
      type,
      district: area.district,
      title: `${community}·${lot.label}`,
      layout: lot.layout,
      area: size,
      floor,
      price: total,
      unit: '万',
      tags: pickTags(rng, type),
    })
  }
  return list
}
function makeRent(count) {
  const list = []
  for (let i = 0; i < count; i++) {
    const id = ++seq
    const rng = mulberry32(id * 2654435761)
    const area = pick(rng, AREAS)
    const community = pick(rng, area.names)
    const lot = pick(rng, RENT_LAYOUTS)
    const size = between(rng, lot.area[0], lot.area[1])
    const rent = Math.round((size * (26 + rng() * 32)) / 100) * 100
    list.push({
      id,
      type: '租赁',
      district: area.district,
      title: `${community}·${lot.label}`,
      layout: lot.layout,
      area: size,
      floor: pick(rng, FLOORS),
      price: rent,
      unit: '元/月',
      tags: pickTags(rng, '租赁'),
    })
  }
  return list
}
function makeShop(count) {
  const list = []
  for (let i = 0; i < count; i++) {
    const id = ++seq
    const rng = mulberry32(id * 2654435761)
    const area = pick(rng, SHOP_AREAS)
    const community = pick(rng, area.names)
    const lot = pick(rng, SHOP_LAYOUTS)
    const size = between(rng, lot.area[0], lot.area[1])
    const rent = Math.round((size * (60 + rng() * 130)) / 100) * 100
    list.push({
      id,
      type: '商铺',
      district: area.district,
      title: `${community}·${lot.label}`,
      layout: lot.layout,
      area: size,
      floor: pick(rng, SHOP_FLOORS),
      price: rent,
      unit: '元/月',
      tags: pickTags(rng, '商铺'),
    })
  }
  return list
}

// 连续分配图片：同一图库内按顺序取图，重复间隔最大化；
// 二手房与新房共用住宅图库并连续编号，避免两个列表出现完全相同的图片顺序
function assignImages(list, pool) {
  list.forEach((item, idx) => {
    item.image = pool[idx % pool.length]
  })
  return list
}

const residential = [...makeResidential('二手房', 26), ...makeResidential('新房', 25)]
assignImages(residential, RESIDENTIAL_IMGS)
const rentals = assignImages(makeRent(25), INT)
const shops = assignImages(makeShop(24), SHOP)

export const properties = [...residential, ...rentals, ...shops]

// 首页精选：各类型各取几套，保证多样性
export const featured = [
  properties.find((p) => p.type === '二手房'),
  properties.find((p) => p.type === '新房'),
  properties.find((p) => p.type === '租赁'),
].filter(Boolean)
